import "core-js/modules/es.number.constructor.js"; //
//
//
//
//
//
//
//

import RecommendItem from '@/components/home/RecommendItem';
export default {
  name: 'recommend-list',
  components: {
    RecommendItem: RecommendItem
  },
  props: {
    recommendList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    defaultColor: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isRecommendABtest: {
      type: Number,
      default: 0
    }
  },
  watch: {},
  mounted: function mounted() {},
  methods: {}
};